(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('centro-docente', {
            parent: 'entity',
            url: '/centro-docente',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'CentroDocentes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/centro-docente/centro-docentes.html',
                    controller: 'CentroDocenteController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('centro-docente-detail', {
            parent: 'centro-docente',
            url: '/centro-docente/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'CentroDocente'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/centro-docente/centro-docente-detail.html',
                    controller: 'CentroDocenteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'CentroDocente', function($stateParams, CentroDocente) {
                    return CentroDocente.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'centro-docente',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('centro-docente-detail.edit', {
            parent: 'centro-docente-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/centro-docente/centro-docente-dialog.html',
                    controller: 'CentroDocenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CentroDocente', function(CentroDocente) {
                            return CentroDocente.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('centro-docente.new', {
            parent: 'centro-docente',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/centro-docente/centro-docente-dialog.html',
                    controller: 'CentroDocenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('centro-docente', null, { reload: 'centro-docente' });
                }, function() {
                    $state.go('centro-docente');
                });
            }]
        })
        .state('centro-docente.edit', {
            parent: 'centro-docente',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/centro-docente/centro-docente-dialog.html',
                    controller: 'CentroDocenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CentroDocente', function(CentroDocente) {
                            return CentroDocente.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('centro-docente', null, { reload: 'centro-docente' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('centro-docente.delete', {
            parent: 'centro-docente',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/centro-docente/centro-docente-delete-dialog.html',
                    controller: 'CentroDocenteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CentroDocente', function(CentroDocente) {
                            return CentroDocente.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('centro-docente', null, { reload: 'centro-docente' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
